'use strict';

var cart = require('../cart/cart');
const toastMessageHelper = require('../utils/toastMessageHelper');

var updateMiniCart = true;
var location = window.location;

/**
 * Removes line-item-attributes elements that contain only whitespace
 * @param {string|Element} container - selector or DOM element to search within
 */
function removeEmptyAttributes(container) {
    $(container).find('.line-item-attributes').filter(function () {
        return !$(this).text().trim();
    }).remove();
}

module.exports = function () {
    cart();

    /**
     * Handle successful move to wishlist action
     */
    function handleMoveToWishlistSuccess() {
        var moveToWishlistMessage = $('#movedToWishlist').val();
        $('.cart-delete-confirmation-btn').trigger('click', moveToWishlistMessage);
    }

    /**
     * Handle move to wishlist error
     */
    function handleMoveToWishlistError() {
        var errorMessage = $('#unableToProcess').val();
        toastMessageHelper.showNotification(errorMessage);
    }

    $('.minicart').on('count:update', function (event, count) {
        if (count && $.isNumeric(count.quantityTotal || count.numItems)) {
            $('.minicart .minicart-quantity').text(count.quantityTotal || count.numItems);
            $('.minicart .minicart-link').attr({
                'aria-label': count.minicartCountOfItems,
                title: count.minicartCountOfItems
            });
        }
    });

    $('.minicart').on('mouseenter focusin touchstart', function () {
        var url = $('.minicart').data('action-url');
        var count = parseInt($('.minicart .minicart-quantity').text(), 10);

        if (count !== 0 && $('.minicart .popover.show').length === 0) {
            if (!updateMiniCart) {
                $('#currency-list, #languages-list').collapse('hide');
                $('.minicart .popover').addClass('show');
                return;
            }

            $('#currency-list, #languages-list').collapse('hide');
            $('.minicart .popover').addClass('show');
            $.get(url, function (data) {
                $('.minicart .popover').empty();
                $('.minicart .popover').append(data);
                removeEmptyAttributes('.minicart .popover');
                updateMiniCart = false;
            });
        }
    });

    $('.minicart .minicart-total, .minicart .right-nav-items-names').on('click', function () {
        $.spinner().start();
        window.location.href = $('.minicart.minicart-link').data('cart-url');
    });

    $('.minicart-tab.minicart .minicart-total, .minicart-tab.minicart .right-nav-items-names').on('touchstart mousedown', function (e) {
        e.preventDefault();
        $('.more-active-section').addClass('collapse');
        $('.category-backdrop').addClass('d-lg-none');
        $('.l1-category-item').removeClass('show');
        $('body').removeClass('overflow-hidden');
    });

    var touchTimer = null;
    var longPressTriggered = false;

    $('.minicart').on('touchstart', function () {
        longPressTriggered = false;
        touchTimer = setTimeout(function () {
            longPressTriggered = true;
            // Long press - open minicart
            var url = $('.minicart').data('action-url');
            var count = parseInt($('.minicart .minicart-quantity').text(), 10);
            if (count !== 0 && $('.minicart .popover.show').length === 0) {
                $('#currency-list, #languages-list').collapse('hide');
                $('.minicart .popover').addClass('show');
                if (updateMiniCart) {
                    $.get(url, function (data) {
                        $('.minicart .popover').empty();
                        $('.minicart .popover').append(data);
                        removeEmptyAttributes('.minicart .popover');
                        updateMiniCart = false;
                    });
                }
            }
        }, 500);
    });

    $('.minicart').on('touchend touchcancel', function () {
        if (touchTimer) {
            clearTimeout(touchTimer);
        }
        if (!longPressTriggered) {
            // Single tap - redirect to cart
            $.spinner().start();
            window.location.href = $('.minicart.minicart-link').data('cart-url');
        }
    });

    $('body').on('touchstart', function (e) {
        if ($('.minicart').has(e.target).length <= 0) {
            $('.minicart .popover').removeClass('show');
        }
    });
    $('.minicart').on('mouseleave focusout', function (event) {
        if ((event.type === 'focusout' && $('.minicart').has(event.target).length > 0)
            || (event.type === 'mouseleave' && $(event.target).is('.minicart .quantity'))
            || $('body').hasClass('modal-open')) {
            event.stopPropagation();
            return;
        }
        $('.minicart .popover').removeClass('show');
    });
    $('body').on('change', '.minicart .quantity', function () {
        if ($(this).parents('.bonus-product-line-item').length && $('.cart-page').length) {
            location.reload();
        }
    });
    $('body').on('product:afterAddToCart', function () {
        updateMiniCart = true;
    });
    $('body').on('cart:update', function () {
        updateMiniCart = true;
    });
    $('body').on('click', '.remove-product-modal .move-to-wishlist-btn', function (e) {
        e.preventDefault();
        var userAuthenticated = $('#isAuthenticated').val();
        if (userAuthenticated === 'true') {
            var isGlobalDelete = $('#removeProductModal').data('globalDelete');

            // Handle bulk move to wishlist (global delete)
            if (isGlobalDelete === true) {
                var data = [];
                $('.cartdetails .toggle-pli-select:checked:not(:disabled)').each(function (ind, el) {
                    data.push({
                        pid: $(el).data('pid'),
                        uuid: $(el).data('uuid'),
                        quantity: $(el).data('quantity')
                    });
                });

                if (data.length > 0) {
                    $(document).trigger('cart:moveToWishlist', JSON.stringify(data));
                }
                return;
            }

            // Handle single product move to wishlist
            var url = $(this).attr('href');
            var pid = $(this).data('pid');
            var optionId = $(this).closest('.product-info').find('.lineItem-options-values').data('option-id');
            var optionVal = $(this).closest('.product-info').find('.lineItem-options-values').data('value-id');
            optionId = optionId || null;
            optionVal = optionVal || null;
            if (!url || !pid) {
                return;
            }

            // Check if product already exists in wishlist
            var wishlistStatusUrl = $(this).data('wishlist-status-url');
            $.ajax({
                url: wishlistStatusUrl,
                type: 'get',
                data: { pid: pid },
                success: function (response) {
                    var $response = $(response);
                    var inWishlist = $response.find('.wishlist-btn').hasClass('is-active');

                    if (inWishlist) {
                        // Product already in wishlist, just remove from cart
                        var toastMessage = $('#movedToWishlist').val();
                        $('.cart-delete-confirmation-btn').trigger('click', toastMessage);
                    } else {
                        // Product not in wishlist, add it
                        $.ajax({
                            url: url,
                            type: 'post',
                            dataType: 'json',
                            data: {
                                pid: pid,
                                optionId: optionId,
                                optionVal: optionVal
                            },
                            success: handleMoveToWishlistSuccess,
                            error: handleMoveToWishlistError
                        });
                    }
                },
                error: function () {
                    $.ajax({
                        url: url,
                        type: 'post',
                        dataType: 'json',
                        data: {
                            pid: pid,
                            optionId: optionId,
                            optionVal: optionVal
                        },
                        success: handleMoveToWishlistSuccess,
                        error: handleMoveToWishlistError
                    });
                }
            });
        } else {
            $('#removeProductModal').modal('hide');
            $('#ckc-login-modal').modal('show');
            var $wrap = $('.ckc-login-countrycode-drop-down');
            $wrap.find('.custom-option-value.active, .custom-option-value.selected').removeClass('active selected');
            var $defaultOption = $wrap.find('.custom-option-value[data-id="+91"]');
            $defaultOption.addClass('active selected');
            $wrap.find('.custom-drop-down-login .selected-value').text($defaultOption.data('id')).addClass('active');
            $('#loginInput').addClass('w-100 border-left border-1').removeClass('country-code-field');

            e.preventDefault();
            $('.country-select-wrap').addClass('d-none');
            $('#loginInput').addClass('w-100');
            $('.login-modal-missing-error, .login-modal-customer-exists-error, .login-modal-result, .login-mobile-country-miss-match-error, #register-form-modal, .ckc-password-register-content, .ckc-register-form-content').addClass('d-none');
            window.localStorage.setItem('wishlistPid', '');
        }
    });
};
